import { render } from "./TentangKami.vue?vue&type=template&id=36ca070c&scoped=true"
import script from "./TentangKami.vue?vue&type=script&lang=js"
export * from "./TentangKami.vue?vue&type=script&lang=js"

import "./TentangKami.vue?vue&type=style&index=0&id=36ca070c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ca070c"]])

export default __exports__